var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb-item',{attrs:{"to":{path: _vm.to},"replace":_vm.replace}},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }